import React, { useEffect } from 'react';

const PoliticaComercialPescaUS = () => {

    const discountData = [
        { from: "$0.00", to: "$9,999.00", discount: "0%" },
        { from: "$10,000.00", to: "$29,999.00", discount: "2%" },
        { from: "$30,000.00", to: "$59,999.00", discount: "4%" },
        { from: "$60,000.00", to: "$99,999.00", discount: "6%" },
        { from: "$100,000.00", to: "$299,999.00", discount: "8%" },
        { from: "$300,000.00", to: ">", discount: "12%" },
    ];

    return (
        <section className="fale-conosco container">
            <div className="sect-header">
                <div className="sect-titulo">
                    <h1>Commercial Policy</h1>
                </div>
                <hr />
            </div>
            <div className="subtitulo-politics">
                <h4>Objective</h4>
                This document aims to establish the basic rules of Shimano Mexico to define the marketing strategy. This policy is
                fundamental for the proper functioning of the company, as commercial results will directly depend on it.
            </div>
            <div className="subtitulo-politics">
                <span>1. Payment Terms (Credit Period):</span><br /><br />
                The history each client has had with the Shimano brand will be taken as a basis. The payment terms are as follows:
                <ul>
                    <li><b>Payment in Advance:</b> This term applies to new clients and those who do not have a credit history with the brand.
                    </li>
                    <li><b>30 Days:</b> Based on the account history, a minimum period of three months will be taken, and an evaluation will be
                        carried out to determine if the client is eligible for thirty-day financing.
                    </li>
                </ul>
                Clients with delayed payments on their invoices will enter a period of account freeze for their subsequent orders. The account
                will be reactivated once 100% of the total overdue amount is received. In addition to the above, from the 1st day of delay,
                a penalty equivalent to 5% monthly (prorated) of the total debt will be applied. Similarly, their credit limit will be
                decreased by 50%, and they will have to wait a period of 3 months to access their initial credit limit. If the delay is
                greater than 8 weeks, 100% of the credit limit will be lost, and the client will move to an advance payment scheme.
            </div>
            <div className="subtitulo-politics">
                <span>2. Credit Limit:</span><br /><br />
                Without exception, all clients with a credit period must be previously documented with a promissory note that legally
                backs the value of their credit. Clients interested in increasing their credit limit must show a minimum history of 3 months
                of punctual payments in time to be able to access a 20% increase over their current credit amount. Ideally, the client
                should present proof of credit limit with other suppliers and, if possible, their financial statements as support. All credit
                increases must be approved by Shimano Mexico and in some cases, the increase may not apply if the company decides so.
            </div>
            <div className="subtitulo-politics">
                <span>3. Electronic Wallets:</span><br /><br />
                Clients with a credit line. Once the invoice is paid before its due date, a 1% bonus will be obtained in an electronic
                wallet, which will be valid and must be used before the end of the current year.
            </div>
            <div className="subtitulo-politics">
                <span>4. Distribution Channels:</span><br /><br />
                The established distribution channels are listed below. For strategic reasons, selling to other channels not listed is
                not permitted:<br /><br />
                <ul>
                    <li><b>Specialized Fishing Store</b>: Stores dedicated to sport fishing that handle different brands.</li>
                    <li><b>Hunting and Fishing</b>: Stores that handle hunting, archery, camping, and sport fishing products.</li>
                    <li><b>Marine Hardware Store</b>: Stores with tools, marine spare parts, and sport fishing.</li>
                    <li><b>Department Stores</b>: With departments specialized in sports.</li>
                    <li><b>Boats and Fishing</b>: Specialized in boats, engines, and equipment for sport fishing.</li>
                    <li><b>Sports Stores</b>: Specialized in 2 or 3 different sports, including sport fishing.</li>
                    <li><b>Tourism</b>: Specialists in promoting fishing who have their own store.</li>
                    <li><b>Commercial and Sport Fishing</b>: Fishing stores, selling nets and harpoons, that also have sport fishing sales.</li>
                    <li><b>Wholesaler</b>: Clients with warehouses or their own stores dedicated to marketing the brand.</li>
                    <li><b>Fishing Workshops</b>: Establishments dedicated to the maintenance of fishing equipment.</li>
                    <li><b>Pet Shop</b>: Stores that handle pet products with a sport fishing section.</li>
                    <li><b>E-Commerce</b>: Clients whose business model is online but also have a physical store.</li>
                </ul>
            </div>

            <div className="subtitulo-politics">
                <span>5. Discounts:</span><br /><br />
                Shimano Mexico will have quarterly billing reviews for discount adjustments based on the average monthly history.

                <div style={{ padding: '20px', maxWidth: '600px', margin: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th colSpan="3" style={{ ...thStyle, textAlign: 'center', backgroundColor: '#e0e0e0' }}>
                                    DISCOUNT BASED ON AVERAGE MONTHLY PURCHASE
                                </th>
                            </tr>
                            <tr>
                                <th style={thStyle}>FROM</th>
                                <th style={thStyle}>TO</th>
                                <th style={thStyle}>% DISCOUNT</th>
                            </tr>
                        </thead>
                        <tbody>
                            {discountData.map((row, index) => (
                                <tr key={index}>
                                    <td style={tdStyle}>{row.from}</td>
                                    <td style={tdStyle}>{row.to}</td>
                                    <td style={tdStyle}>{row.discount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                An additional <b>3%</b> discount will be obtained on orders paid in advance, as long as the client has credit.
            </div>
            <div className="subtitulo-politics">
                <span>All discounts must have prior authorization from the Commercial Management.</span><br /><br />
                These discounts will be granted based on the monthly purchase history. A quarterly review of the billed amount will be
                conducted to make decisions on increasing or decreasing them.
            </div>

            <div className="subtitulo-politics">
                <span>6. Promissory Note and Credit Bureau</span><br /><br />
                For credit authorization, a promissory note must be signed, as well as the document authorizing consultation with the
                Credit Bureau.
            </div>

            <div className="subtitulo-politics">
                <span>7. Minimum Purchase and Shipping</span><br /><br />
                The minimum purchase will be $2,000.00 + VAT MXN with a shipping cost of $200.00 + VAT MXN. The minimum order amount to be
                eligible for free shipping will be $5,000.00 + VAT MXN.
            </div>

            <div className="subtitulo-politics">
                <span>8. Documents and Data</span><br /><br />
                <ul>
                    <span>Documents</span><br />
                    <li>Incorporation certificate (in case of a legal entity), official identification of the legal representative on both sides,
                        updated tax situation certificate, proof of tax domicile no more than three months old, commercial policy
                        signed by the legal representative.</li>
                    <span>Data</span><br />
                    <li>Name of the business name, whether physical or legal, use of CFDI, contact phone, name of the contact(s),
                        delivery address.</li></ul>
            </div>

            <div className="subtitulo-politics">
                <span>9. Payment Methods</span><br /><br />
                All invoices must be paid via electronic transfer or deposit at a bank window to our account. <b>Payments in cash or by
                    check are not accepted</b>. Likewise, it is <b>essential and strict</b> that the <b>invoice or order number</b> is included in the
                reference number of the transfer or deposit. If this reference is not included, Shimano Mexico will not be able to associate
                the payment with an invoice or order and it will not be able to be identified.
            </div>

            <div className="subtitulo-politics">
                <span>10. Invoicing</span><br /><br />
                Shimano Mexico does not guarantee that orders entered or paid (in the case of advance payment orders which must be paid
                prior to invoicing and shipping) will be invoiced within the same current month. Logically, we will always try to invoice
                and ship orders within the same month they are received; however, in the last 3 days of the month due to the heavy volume
                of orders, we do not guarantee this will always be possible.
            </div>

            <div className="subtitulo-politics">
                <span>11. Exclusivity over distribution:</span><br /><br />
                Shimano Mexico does not guarantee exclusivity in the distribution of products by area that are acquired directly with the
                brand at the moment they are registered with the company.
                <br /><br />
                All clients must know their commercial conditions in writing. Therefore, it is necessary that all our clients understand
                and sign the commercial policies.
                <br />
            </div>
        </section >
    );
};

const thStyle = {
    border: '1px solid #ccc',
    padding: '10px',
    backgroundColor: '#f5f5f5',
    textAlign: 'center',
};

const tdStyle = {
    border: '1px solid #ccc',
    padding: '10px',
    textAlign: 'center',
};

export default PoliticaComercialPescaUS;

